import styled from 'styled-components';
import {device} from '../../../../utils/device';
import bg1 from '../../assets/heroplus-bg1.png';
import bg2 from '../../assets/heroplus-bg2.png';
import bg3 from '../../assets/heroplus-bg3.png';

export const Container = styled.div`
  h3 {
    text-align: center;
    font-size: 32px;
    line-height: 42px;
    color: #4e3f6e;
    font-weight: 400;
    margin-bottom: 60px;
    span {
      font-weight: 900;
    }
    @media ${device.mobileS} {
      font-size: 24px;
      line-height: 32px;
      text-align: center;
      max-width: 280px;
      margin: 0 auto;
      margin-bottom: 20px;
      font-weight: 300;
    }
  }
  padding: 80px 0;
  @media ${device.mobileS} {
    padding: 30px 20px;
  }
`;
export const ContainerInner = styled.div`
  //max-width: 976px;
  margin: 0 auto;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  @media ${device.mobileS} {
    flex-direction: column;
  }
  img.icon {
    width: 96px;
    margin-bottom: 10px;
    position: relative;
    z-index: 2;
    @media ${device.mobileS} {
      width: 62px;
      margin-bottom: 0;
    }
  }
  h4 {
    font-size: 24px;
    line-height: 31px;
    font-weight: 900;
  }
  h5 {
    font-size: 18px;
    line-height: 24px;
    margin-top: 6px;
    font-weight: 400;
    span {
      font-weight: 900;
    }
  }
  ul {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    margin-top: 30px;
    @media ${device.mobileS} {
      gap: 8px;
      margin-top: 20px;
    }
    li {
      display: flex;
      align-items: center;
      p {
        font-size: 18px;
        line-height: 24px;
        span {
          font-weight: 900;
        }
        @media ${device.mobileS} {
          font-size: 14px;
          line-height: 20px;
        }
      }
      .highlightText {
        background: #fbdf6a;
      }
      .ic_tick,
      .ic_tickWhite {
        margin-right: 16px;
        @media ${device.mobileS} {
          transform: scale(0.7);
          margin-left: -3px;
          margin-right: 8px;
        }
      }
    }
  }
`;
export const Hero = styled.div`
  width: 400px;
  flex-shrink: 0;
  background-color: #fff;
  border: 2px #4d49724d solid;
  border-radius: 10px;
  padding: 40px;
  h4 {
    text-align: center;
  }
  img {
    display: block;
    margin: 0 auto;
    width: 96px;
    height: 120px;
  }
  .highlightText {
    background: #fbdf6a;
  }
  @media ${device.mobileS} {
    width: 100%;
    padding: 24px;
    margin-bottom: 36px;
  }
  .ulHero {
    margin-top: 50px;
  }
`;
export const HeroPlus = styled.div`
    width: 400px;
    flex-shrink: 0;
    background: linear-gradient(180deg, rgba(120, 31, 3, 0.1) 2.35%, rgba(217, 217, 217, 0) 110.45%);
    border: 2px solid;
    border-image: linear-gradient(13.6deg, #FDD934 12.91%, #DD9A07 27.78%, #FFE600 40.59%, #FDD934 54.73%, #FDCF6B 62.16%, #C29803 78.14%, #FAFF00 87.2%, #FFB617 98.41%) 0;
    border-radius: 16px;
    padding: 40px;
    position: relative;
    h4{
      text-align: center;
    }
    .highlightText {
      background: #fbdf6a;
    }
    img{
        display: block;
        margin: 0 auto;
        margin-top: 18px;
        margin-bottom: 10px;
    }
    @media ${device.mobileS} { 
        width: 100%;
        padding: 24px;
    }
    .bg1{
        width: 179px;
        height: 185px;
        background: url('${bg1}') 0 0 no-repeat;
        background-size: 179px 185px;
        position: absolute;
        left: 0;
        top: 0;
        @media ${device.mobileS} { 
            display: none;
        }
    }
    .bg2{
        width: 88px;
        height: 80px;
        background: url('${bg2}') 0 0 no-repeat;
        background-size: 88px 80px;
        position: absolute;
        right: 0;
        top: 0;
        opacity: 0.5;
        @media ${device.mobileS} { 
            display: none;
        }
    }
    .bg3{
        width: 105px;
        height: 69px;
        background: url('${bg3}') 0 0 no-repeat;
        background-size: 105px 69px;
        position: absolute;
        right: 20px;
        bottom: 0;
        opacity: 0.5;
        @media ${device.mobileS} { 
            display: none;
        }
    }
`;
export const HeroPlusNewTag = styled.span`
  background: linear-gradient(53.72deg, #43e1a8 9.59%, #219393 60.86%);
  border-radius: 30px;
  width: 60px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff;
  position: absolute;
  left: 30px;
  top: -12px;
  @media ${device.mobileS} {
    left: 24px;
  }
`;
